<template>
  <div>
    <div v-if="debtMessage" class="card-item notification-content">
      <div class="notification">
        <h4>{{ debtMessage }}</h4>
      </div>
    </div>
    <div
      v-if="listPaymentsMethods.length !== 0"
      id="payment-provider-card"
      class="card-item payout-content">
      <h3 class="text-align-center">Elige tu medio de pago</h3>
      <div class="pay-content">
        <div
          v-for="(method, indexMethod) in listPaymentsMethods"
          :id="method.slug"
          :key="indexMethod"
          class="pay-item card-item"
          :class="{
            'selected': $store.state.paymentsModule.paymentMethod.slug === method.slug,
            'selected-neat': method.slug === 'NEAT_TRANSFER' && $store.state.paymentsModule.paymentMethod.slug === 'NEAT_TRANSFER',
            'selected-servipag': method.slug === 'SERVIPAG_BUTTON' && $store.state.paymentsModule.paymentMethod.slug === 'SERVIPAG_BUTTON'
          }"
          @click="selectMethod(method, method.nameNextRoute)">
          <div class="round-choice-content">
            <input
              type="radio"
              name="method-pay"
              :checked="$store.state.paymentsModule.paymentMethod.slug === method.slug"
              class="input-choice">
            <label :for="method.slug" class="label-choice transition-fast" />
          </div>
          <div v-if="method.slug === 'SERVIPAG_BUTTON'">
            <div class="text-item-svg">
              <img alt="servipag logo" src="@/ui/assets/img/servipag.svg" :class="`img-gray ${method.icon}`">
            </div>
            <p class="pay-method">
              {{ method.name }}
            </p>
          </div>
          <div v-else-if="method.slug === 'NEAT_TRANSFER'">
            <div class="text-item-svg">
              <img alt="neat logo" src="@/ui/assets/img/neat.svg" :class="`img-gray ${method.icon}`">
            </div>
            <p class="pay-method">
              {{ method.name }}
            </p>
            <p class="pay-method-sub">
              (Tarjeta de crédito)
            </p>
          </div>
          <div v-else-if="method.slug === 'CASH_DEPOSIT'">
            <div class="text-item">
              <img src="@/ui/assets/img/efectivo.svg" alt="efectivo logo" :class="`${method.icon}`">
            </div>
            <p class="pay-method">{{ method.name }}</p>
          </div>
          <div v-else-if="method.slug === 'WIRE_TRANSFER'">
            <div class="text-item">
              <img src="@/ui/assets/img/transferencia.svg" alt="transferencia logo" :class="`${method.icon}`">
            </div>
            <p class="pay-method">{{ method.name }}</p>
          </div>
          <div v-else>
            <div class="text-item">
              <img v-if="method.img" :src="method.img" alt="">
              <span v-else :class="`fas ${method.icon}`" />
            </div>
            <p class="pay-method">{{ method.name }}</p>
          </div>
        </div>
      </div>
      <div class="descriptions-methods-content">
        <div v-for="(method, indexMethod) in listPaymentsMethods" :key="indexMethod">
          <div
            :ref="`decription-${method.slug}`"
            class="description-content"
            :class="$store.state.paymentsModule.paymentMethod.slug === method.slug ? 'show' : ''">
            <p v-html="method.description" />
          </div>
        </div>
        <div v-if="errorMessage" class="notification is-warning">
          <button class="delete" @click="errorMessage = ''" />
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  setTransactionProvider,
  getTransactionsProviders
} from '@/application/services/api-clients/transactions';

export default {
  name: 'Pay',
  data() {
    return {
      debtMessage: '',
      listPaymentsMethods: [],
      errorMessage: '',
      slug: this.$store.state.paymentsModule.paymentMethod.slug,
      currentNextRoute: '',
      transactionId: this.$store.state.paymentsModule.transactionData._id
    };
  },
  async mounted() {
    this.listPaymentsMethods = await getTransactionsProviders();
    this.$emit('enableNextButton', this.slug !== undefined);
    this.$emit('sendNameBackStep', 'choice');
    if (this.slug !== '') {
      const currentMethod = this.$store.state.paymentsModule.paymentMethod;
      this.selectMethod(currentMethod, currentMethod.nameNextRoute);
    }
  },
  beforeDestroy() {
    this.$emit('set-event-next', () => {
    });
  },
  methods: {
    selectMethod(value, nextRoute) {
      this.currentNextRoute = nextRoute;
      this.$store.dispatch('setPaymentMethod', value);
      this.$emit('sendNameNextStep', this.currentNextRoute);
      this.$emit(
        'enableNextButton',
        this.$store.state.paymentsModule.paymentMethod.slug !== undefined
      );
      this.$emit('setTransactionId', this.transactionId);
      this.$emit('set-event-next', async () => {
        const {
          transaction,
          xml1
        } = await setTransactionProvider(this.transactionId, value.slug);
        this.$store.dispatch('setTransactionData', transaction);
        if (xml1) {
          this.$store.dispatch('setXML1', xml1);
        }
      });
    }
  }
};
</script>
<style scoped>
.card-item {
  overflow: hidden;
}

.img-gray {
  -webkit-filter: grayscale(100%);
}

.payout-content {
  width: 95%;
  margin: 30px auto 50px auto;
  align-content: center;
}

.pay-content {
  width: 100%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  place-items: stretch center;
}

.pay-content .pay-item {
  width: 12rem;
  margin: 0.65rem;
  box-shadow: var(--complete-shadow);
  border-radius: 1.35rem;
  text-align: center;
  padding: 1rem;
  cursor: pointer;
}

.pay-content .pay-item.selected {
  box-shadow: 0px 0px 10px var(--primary);
}

.pay-content .pay-item.selected-neat img {
  -webkit-filter: grayscale(0%);
}

.pay-content .pay-item.selected-servipag img {
  -webkit-filter: grayscale(0%);
}

.pay-content .pay-item .round-choice-content {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
}

.pay-content .pay-item .pay-method {
  position: relative;
  margin: auto;
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  padding: 5px;
  border-radius: 40px;
  color: var(--primary);
  text-align: center;
}

.pay-content .pay-item .pay-method-sub {
  position: relative;
  margin: auto;
  font-size: 14px;
  width: 100%;
  padding: 0;
  border-radius: 40px;
  color: var(--secondary);
  text-align: center;
}

.pay-content .pay-item .text-item {
  margin-top: 15px;
  font-size: 30px;
}

.pay-content .pay-item .text-item img {
  margin-top: 15px;
  font-size: 30px;
}

.pay-content .pay-item .text-item-svg {
  padding-top: 30px;
  font-size: 30px;
}

.svg-efectivo {
  width: 1.5639453125em;
}

.svg-neat {
  width: 1.8135609375em;
}

.svg-servipag {
  width: 4.0865625em;
}

.svg-transferencia {
  width: 1.4812109375em;
}

@media (max-width: 550px) {
  .pay-content {
    width: 220px !important;
    display: block;
  }

  .pay-content {
    margin: auto;
    display: flex;
    flex-wrap: wrap;
  }

  .pay-content .pay-item {
    width: 200px;
    margin: 10px;
    box-shadow: var(--complete-shadow);
    border-radius: 20px;
    text-align: center;
    float: left;
    position: relative;
    padding: 15px;
  }

  .pay-content .pay-item .round-choice-content {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
  }

  .pay-content .pay-item .pay-method {
    position: relative;
    margin: auto;
    font-size: 15px;
    font-weight: bold;
    width: 100%;
    padding: 5px;
    border-radius: 40px;
    color: var(--primary);
    text-align: center;
  }

  .pay-content .pay-item .pay-method-sub {
    position: relative;
    margin: auto;
    font-size: 14px;
    width: 100%;
    padding: 0;
    border-radius: 40px;
    color: var(--secondary);
    text-align: center;
  }

  .pay-content .pay-item .text-item {
    margin-top: 15px;
    font-size: 30px;
  }

  .pay-content .pay-item .text-item img {
    margin-top: 15px;
    font-size: 30px;
  }

  .pay-content .pay-item .text-item-svg {
    padding-top: 30px;
    font-size: 30px;
  }

  .pay-content {
    width: 220px !important;
    display: block;
  }

  .pay-content .pay-item .round-choice-content {
    position: absolute;
    width: 25px;
    height: 25px;
  }
}

@media (max-width: 330px) {
  .text-align-center {
    font-size: 22px;
  }
}
</style>
<style>
.descriptions-methods-content {
  width: 100%;
  float: left;
  background-color: #f5f5f5;
  border-radius: 20px;
  margin-top: 30px;
}

.descriptions-methods-content .description-content {
  width: 90%;
  margin: auto;
  padding: 0px;
  font-size: 14px;
  text-align: justify;
  max-height: 0px;
  overflow: hidden;
}

.descriptions-methods-content .description-content.show {
  padding: 40px;
  max-height: 999px;
  transition: max-height 3s ease, padding-top 1s ease, padding-bottom 1s ease;
}

.descriptions-methods-content .description-content ul {
  display: block;
  margin: 10px;
  float: left;
  width: calc(50% - 40px);
}

.descriptions-methods-content .description-content ul li {
  padding-left: 20px;
  margin-bottom: 10px;
  position: relative;
}

.descriptions-methods-content .description-content ul li:before {
  content: "\f058";
  height: 20px;
  width: 20px;
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  position: absolute;
  left: 0;
  color: var(--primary);
}

.descriptions-methods-content .description-content .more-info {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 20px;
  float: left;
}

.descriptions-methods-content .description-content .extra-info {
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  float: left;
}

@media (max-width: 1050px) {
  .descriptions-methods-content .description-content {
    font-size: 12px;
  }

  .descriptions-methods-content .description-content .more-info {
    font-size: 12px;
    margin-top: 10px;
  }

  .descriptions-methods-content .description-content .extra-info {
    font-size: 11px;
  }
}

@media (max-width: 932px) {
  .descriptions-methods-content .description-content p {
    font-size: 12px;
  }

  .descriptions-methods-content .description-content ul {
    font-size: 10px;
  }
}

@media (max-width: 860px) {
  .descriptions-methods-content .description-content p {
    margin-bottom: 5px;
  }

  .descriptions-methods-content .description-content ul {
    margin: 0px 10px;
    width: calc(50% - 20px);
  }

  .descriptions-methods-content .description-content ul li {
    margin-bottom: 5px;
  }
}

@media (max-width: 810px) {
  .descriptions-methods-content .description-content ul li {
    width: calc(50% - 5px);
  }

  .descriptions-methods-content .description-content ul {
    margin: 0px 1px;
  }

  .descriptions-methods-content .description-content ul {
    font-size: 8px;
  }

  .descriptions-methods-content .description-content p {
    font-size: 10px;
  }

  .descriptions-methods-content .description-content .more-info {
    font-size: 10px;
  }

  .descriptions-methods-content .description-content .extra-info {
    font-size: 9px;
  }
}

@media (max-width: 768px) {
  .descriptions-methods-content .description-content p {
    font-size: 12px;
  }

  .descriptions-methods-content .description-content ul {
    font-size: 10px;
  }

  .descriptions-methods-content .description-content .more-info {
    font-size: 12px;
  }

  .descriptions-methods-content .description-content .extra-info {
    font-size: 11px;
  }
}

@media (max-width: 610px) {
  .descriptions-methods-content .description-content ul {
    width: 100%;
  }
}

@media (max-width: 430px) {
  .text-aling-center {
    font-size: 20px;
  }

  .descriptions-methods-content .description-content {
    width: 100%;
  }

  .descriptions-methods-content .description-content.show {
    padding: 30px;
  }

  .descriptions-methods-content .description-content p {
    font-size: 10px;
  }

  .descriptions-methods-content .description-content ul li {
    width: 100%;
  }

  .descriptions-methods-content .description-content .more-info {
    font-size: 10px;
  }

  .descriptions-methods-content .description-content .extra-info {
    font-size: 9px;
  }
}
</style>
